import React from 'react';
import { CToast, CToastBody, CToastClose } from '@coreui/react';
import './style/style.scss';

interface ICXToastProps {
  message: string;
  autoHide?: boolean;
  delay?: number;
  type?: string;
  className?: string;
}

const CXToast = ({ message, autoHide = true, delay = 5000, type = "success", className }: ICXToastProps) => {
  /*
    ----------------------------- Sample component ------------------------------
    const [text1, setText1] = useState("");
    <CXToast value={text1} placeholder={"Flight Number"} onChange={setText1} />
    ----------------------------- Sample component ------------------------------
  */
  const getToastClass = () => {
    switch(type) {
      case "success":
        return "cx-success-toast";
      case "error":
        return "cx-error-toast";
    }
  }

  return (
    <CToast autohide={true} delay={delay} visible={true} className={`${getToastClass()} cx-toast align-items-center ${className ? className : ''}`}>
      <div className="d-flex cx-toast-flex">
        <CToastBody className="cx-toast-body">{message}</CToastBody>
        <CToastClose className="cx-toast-close" />
      </div>
    </CToast>
  );
};

export default CXToast;